import React from 'react';
import clsx from 'clsx';
import {Outlet} from "react-router-dom";

import css from './MainLayout.module.css';
import {ImportProgressChip} from "../../components/dishesSection/ImportProgressChip/ImportProgressChip";


const MainLayout = () => {

    return (
        <main className={clsx(css.wrap)}>
            <Outlet/>
            {/* Mounted at the root so a running dish import stays visible while
                the admin navigates between tabs. Renders null when idle. */}
            <ImportProgressChip/>
        </main>
    );
};

export {MainLayout};